import Controller from '@ember/controller'
import type RouterService from '@ember/routing/router-service'
import { action } from '@ember/object'
import { service } from '@ember/service'
import type SchoolClass from 'teacher-ui-client/models/school-class'

export default class ManageClassesEditClassController extends Controller {
  @service router!: RouterService

  @action
  async onSchoolClassRemovedTeachers(schoolClass?: SchoolClass) {
    await this.router.replaceWith('manage.classes')
    // unload the record _after_ redirecting, so that we're not on its edit page anymore.
    schoolClass?.unloadRecord()
  }
}

declare module '@ember/controller' {
  interface Registry {
    'manage/classes/school-class': ManageClassesEditClassController
  }
}
